import React from 'react';
import clsx from 'clsx';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import {
  Box,
  Button,
  TextField,
  FormHelperText,
} from '@mui/material';
import { useSnackbar } from 'notistack';

import { updatePassword } from '../../requests/api/auth';
import handleApiResponse from '../../utils/http';
import useStyles from './styles';

function SetPasswordForm({
  className, onSubmitSuccess, token, ...rest
}) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  return (
    <Formik
      initialValues={{
        password: '',
        confirmPassword: '',
      }}
      validationSchema={Yup.object().shape({
        password: Yup.string().max(255).required('Contraseña requerida'),
        confirmPassword: Yup.string().max(255).required('Confirmación de contraseña requerida'),
      })}
      onSubmit={async (values, {
        setSubmitting,
      }) => {
        try {
          const data = {
            token,
            password: values.password,
            confirmPassword: values.confirmPassword,
          };
          const res = await updatePassword(data);

          handleApiResponse(enqueueSnackbar, res, true);
          setSubmitting(false);
          onSubmitSuccess();
        } catch (error) {
          handleApiResponse(enqueueSnackbar, error, false); setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <form
          noValidate
          className={clsx(classes.rootSetPasswordForm, className)}
          onSubmit={handleSubmit}
          {...rest}
        >
          <TextField
            error={Boolean(touched.password && errors.password)}
            // color="primary"
            fullWidth
            autoFocus
            helperText={touched.password && errors.password}
            label="Contraseña"
            margin="normal"
            name="password"
            onBlur={handleBlur}
            onChange={handleChange}
            type="password"
            value={values.password}
            variant="standard"
          />
          <TextField
            error={Boolean(touched.confirmPassword && errors.confirmPassword)}
            fullWidth
            helperText={touched.confirmPassword && errors.confirmPassword}
            label="Confirmar contraseña"
            margin="normal"
            name="confirmPassword"
            onBlur={handleBlur}
            onChange={handleChange}
            type="password"
            value={values.confirmPassword}
            variant="standard"
          />
          <Box mt={2}>
            <Button
              color="secondary"
              disabled={isSubmitting}
              fullWidth
              size="large"
              type="submit"
              variant="contained"
            >
              Actualizar contraseña
            </Button>
            {errors.submit && (
              <Box mt={3}>
                <FormHelperText error>
                  {errors.submit}
                </FormHelperText>
              </Box>
            )}
          </Box>
        </form>
      )}
    </Formik>
  );
}

SetPasswordForm.propTypes = {
  className: PropTypes.object,
  onSubmitSuccess: PropTypes.func,
  token: PropTypes.string,
};

SetPasswordForm.defaultProps = {
  onSubmitSuccess: () => {},
};

export default SetPasswordForm;
